import { Component, Injector } from '@angular/core';

import { BingoSlotRacesComponent, BingoSlotRacesWidgetComponent, BingoSlotRacesWrapperComponent } from '@frontend/bingo/bingo-tournaments';
import { BingoManager, BingoNpmManagerService, BingoTournamentsService, OnAppInitHandler } from '@frontend/bingo/core';
import { ProductService } from '@frontend/vanilla/core';

@Component({
    imports: [BingoSlotRacesComponent, BingoSlotRacesWrapperComponent],
    template: '',
})
export class FrontendBingoLoaderComponent {
    static bingoNpmManagerService = BingoNpmManagerService;
    static bingoManagerService = BingoManager;
    static onAppInitHandler = OnAppInitHandler;
    static bingoTournamentsService = BingoTournamentsService;
    static dynamicComponentsMap = {
        BingoSlotRacesWidgetComponent,
    };
    constructor(
        private productService: ProductService,
        private injector: Injector,
    ) {
        this.productService.register('bingo', this.injector);
    }
}
